import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Footer.st.css';
import { dataHooks } from '../constants';
import Divider from '../../Divider';
import { WixStyleReactContext } from '../../WixStyleReactProvider/context';
import { FooterProps } from './Footer.types';

class Footer extends PureComponent<FooterProps> {
  static displayName = 'Footer';

  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    showDivider: PropTypes.bool,
    noPadding: PropTypes.bool,
  };

  static defaultProps = {
    showDivider: true,
    noPadding: false,
  };

  render() {
    const { children, className, showDivider, noPadding } = this.props;
    return (
      <WixStyleReactContext.Consumer>
        {({ newColorsBranding }) => (
          <div
            className={st(classes.root, { newColorsBranding }, className)}
            data-hook={dataHooks.sidePanelFooter}
          >
            {showDivider && (
              // @ts-ignore
              <Divider dataHook={dataHooks.sidePanelHeaderDivider} />
            )}
            <div
              className={st(classes.footerContainer, {
                noPadding,
              })}
            >
              {children}
            </div>
          </div>
        )}
      </WixStyleReactContext.Consumer>
    );
  }
}

export default Footer;
